import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const SellerList = Loadable(lazy(() => import('views/sellerList/index')));
const AdminUserList = Loadable(lazy(() => import('views/adminUsers/index')));
const AccountSettings = Loadable(lazy(() => import('views/accountSettings/index')));
const UserSeller = Loadable(lazy(() => import('views/userSeller/index')));
const CogsList = Loadable(lazy(() => import('views/itemSku/index')));
const SellerOrderList = Loadable(lazy(() => import('views/sellerOrder/index')));
const ManageStores = Loadable(lazy(() => import('views/manageStores/index')));
const ComingSoon = Loadable(lazy(() => import('views/pages/authentication/ComingSoon')));
const SalesDashboardV2 = Loadable(lazy(() => import('views/salesDashboard-v2/index')));

const PnLDashboard = Loadable(lazy(() => import('views/pnlDashboard/index')));
const PnLByItem = Loadable(lazy(() => import('views/pnlByItem/index')));
const PpcByItem = Loadable(lazy(() => import('views/ppcByItem/index')));
const PpcByCategory = Loadable(lazy(() => import('views/ppcByCategory/index')));
const SalesByItem = Loadable(lazy(() => import('views/salesByItem/index')));
const SalesByCategory = Loadable(lazy(() => import('views/salesByCategory/index')));
const PnlByCategory = Loadable(lazy(() => import('views/pnlByCategory/index')));
const SalesByBrand = Loadable(lazy(() => import('views/salesByBrand/index')));
const PnlItemTags = Loadable(lazy(() => import('views/itemTags/index')));
const PnlGroupBy = Loadable(lazy(() => import('views/groupBypnl/index')));
const ParentSku = Loadable(lazy(() => import('views/parentSku/index')));
const CreateTags = Loadable(lazy(() => import('views/createTag/index')));
const UpdateTag = Loadable(lazy(() => import('views/createTag/UpdateTag')));
const PpcGroupBy = Loadable(lazy(() => import('views/groupByPpc/index')));
const SalesGroupBy = Loadable(lazy(() => import('views/groupBySales/index')));
const SalesByParent = Loadable(lazy(() => import('views/salesByParent/index')));
const PPCByParent = Loadable(lazy(() => import('views/ppcByParent/index')));
const KeywordTracking = Loadable(lazy(() => import('views/keywordTracking/index')));
const UpdateKeyword = Loadable(lazy(() => import('views/editkeywordTracking/index')));
const CreateKeyword = Loadable(lazy(() => import('views/keywordTracking/createKeyword')));

import PrivateRoute from 'PrivateRoute';

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: (
        <PrivateRoute>
          <DashboardDefault />
        </PrivateRoute>
      )
    },
    {
      path: 'dashboard',
      element: (
        <PrivateRoute>
          <DashboardDefault />
        </PrivateRoute>
      )
    },
    {
      path: 'sellers',
      element: (
        <PrivateRoute>
          <SellerList />
        </PrivateRoute>
      )
    },
    {
      path: 'users',
      element: (
        <PrivateRoute>
          <UserSeller />
        </PrivateRoute>
      )
    },
    {
      path: 'cogs-list',
      element: (
        <PrivateRoute>
          <CogsList />
        </PrivateRoute>
      )
    },
    {
      path: 'seller-order',
      element: (
        <PrivateRoute>
          <SellerOrderList />
        </PrivateRoute>
      )
    },
    {
      path: 'manage-store',
      element: (
        <PrivateRoute>
          <ManageStores />
        </PrivateRoute>
      )
    },
    {
      path: 'admin-users',
      element: (
        <PrivateRoute>
          <AdminUserList />
        </PrivateRoute>
      )
    },
    {
      path: 'account-settings',
      element: (
        <PrivateRoute>
          <AccountSettings />
        </PrivateRoute>
      )
    },
    {
      path: 'ppc-campaign',
      element: (
        <PrivateRoute>
          <ComingSoon />
        </PrivateRoute>
      )
    },
    {
      path: 'ppc-group',
      element: (
        <PrivateRoute>
          <ComingSoon />
        </PrivateRoute>
      )
    },
    {
      path: 'ppc-item',
      element: (
        <PrivateRoute>
          <PpcByItem />
        </PrivateRoute>
      )
    },
    {
      path: 'ppc-category',
      element: (
        <PrivateRoute>
          <PpcByCategory />
        </PrivateRoute>
      )
    },
    {
      path: 'sales-dashboard',
      element: (
        <PrivateRoute>
          <SalesDashboardV2 />
        </PrivateRoute>
      )
    },

    {
      path: 'sales-item',
      element: (
        <PrivateRoute>
          <SalesByItem />
        </PrivateRoute>
      )
    },
    {
      path: 'sales-brand',
      element: (
        <PrivateRoute>
          <SalesByBrand />
        </PrivateRoute>
      )
    },
    {
      path: 'sales-category',
      element: (
        <PrivateRoute>
          <SalesByCategory />
        </PrivateRoute>
      )
    },
    {
      path: 'sales-group',
      element: (
        <PrivateRoute>
          <ComingSoon />
        </PrivateRoute>
      )
    },
    {
      path: 'pnl-dashboard',
      element: (
        <PrivateRoute>
          <PnLDashboard />
        </PrivateRoute>
      )
    },
    {
      path: 'pnl-by-category',
      element: (
        <PrivateRoute>
          <PnlByCategory />
        </PrivateRoute>
      )
    },
    {
      path: 'pnl-item',
      element: (
        <PrivateRoute>
          <PnLByItem />
        </PrivateRoute>
      )
    },

    {
      path: 'pnl-tags',
      element: (
        <PrivateRoute>
          <PnlItemTags />
        </PrivateRoute>
      )
    },

    {
      path: 'group-by-pnl',
      element: (
        <PrivateRoute>
          <PnlGroupBy />
        </PrivateRoute>
      )
    },

    {
      path: 'group-by-ppc',
      element: (
        <PrivateRoute>
          <PpcGroupBy />
        </PrivateRoute>
      )
    },

    {
      path: 'group-by-sales',
      element: (
        <PrivateRoute>
          <SalesGroupBy />
        </PrivateRoute>
      )
    },

    {
      path: 'parent-sku',
      element: (
        <PrivateRoute>
          <ParentSku />
        </PrivateRoute>
      )
    },

    {
      path: 'sales-by-parent',
      element: (
        <PrivateRoute>
          <SalesByParent />
        </PrivateRoute>
      )
    },

    {
      path: 'ppc-by-parent',
      element: (
        <PrivateRoute>
          <PPCByParent />
        </PrivateRoute>
      )
    },

    {
      path: 'create-tag',
      element: (
        <PrivateRoute>
          <CreateTags />
        </PrivateRoute>
      )
    },
    {
      path: 'update-tag',
      element: (
        <PrivateRoute>
          <UpdateTag />
        </PrivateRoute>
      )
    },
    {
      path: 'update-keyword',
      element: (
        <PrivateRoute>
          <UpdateKeyword />
        </PrivateRoute>
      )
    },
    {
      path: 'keyword-tracking',
      element: (
        <PrivateRoute>
          <KeywordTracking />
        </PrivateRoute>
      )
    },
    {
      path: 'create-keyword',
      element: (
        <PrivateRoute>
          <CreateKeyword />
        </PrivateRoute>
      )
    },

    {
      path: '*',
      element: (
        <PrivateRoute>
          <DashboardDefault />
        </PrivateRoute>
      )
    }
  ]
};

export default MainRoutes;
